export async function getUrlMetadata(url) {
    try {
      const response = await fetch(`/api/metadata?url=${encodeURIComponent(url)}`)
      const data = await response.json()
      return data
    } catch (error) {
      console.error("Error fetching URL metadata:", error)
      return null
    }
  }
  
  export function isValidUrl(string) {
    try {
      new URL(string)
      return true
    } catch (_) {
      return false
    }
  }
  
  export function getEmbedType(url) {
    try {
      const urlObj = new URL(url)
  
      // YouTube
      if (urlObj.hostname.includes("youtube.com") || urlObj.hostname.includes("youtu.be")) {
        return "youtube"
      }
  
      // Twitter/X
      if (urlObj.hostname.includes("twitter.com") || urlObj.hostname.includes("x.com")) {
        return "twitter"
      }
  
      // Spotify
      if (urlObj.hostname.includes("spotify.com")) {
        return "spotify"
      }
  
      // Image files
      if (url.match(/\.(jpg|jpeg|png|gif|webp)$/i)) {
        return "image"
      }
  
      // Video files
      if (url.match(/\.(mp4|webm|ogg)$/i)) {
        return "video"
      }
  
      // Default to link
      return "link"
    } catch (_) {
      return "link"
    }
  }
  
  export function getYouTubeVideoId(url) {
    try {
      const urlObj = new URL(url)
      if (urlObj.hostname.includes("youtu.be")) {
        return urlObj.pathname.slice(1)
      }
      return urlObj.searchParams.get("v")
    } catch (_) {
      return null
    }
  }
  
  